<script setup>
import Button from '@/Components/Buttons/Button.vue';
import FormButton from '@/Components/Buttons/FormButton.vue';
import {useCart} from '@/stores/cart';
import {mapErrors} from '@/utilities';
import {useForm} from '@inertiajs/vue3';
import {inject} from 'vue';

const cart = useCart();

const route = inject('route');

const form = useForm({
    code: '',
});

function submitForm() {
    form.post(route('public.shopping-cart-coupon.store'), {
        preserveScroll: true,
        onError: (errors) => (form.errors = mapErrors(errors)),
    });
}
</script>

<template>
    <div
        v-if="!cart.hasCoupon"
        class="grid gap-4"
    >
        <div class="flex-1">
            <FormKit
                v-model="form.code"
                type="text"
                name="discount_code"
                :label="$t('Discount code')"
                :errors="form.errors?.code"
                :classes="{'input':'text-black', 'label':'!text-white'}"
                :value="form.code"
            />
        </div>
        <Button
            type="button"
            white
            remove-width
            classes="w-full"
            :label="$t('Apply discount code')"
            :form="form"
            @click="submitForm"
        />
    </div>
    <div
        v-else
        class="grid gap-4"
    >
        <FormButton
            type="button"
            remove-width
            classes="w-full"
            danger
            :label="$t('Remove discount code')"
            method="delete"
            :url="route('public.shopping-cart-coupon.delete')"
        />
    </div>
</template>
